import React from 'react';
import PropTypes from 'prop-types';

const Eye = ({ fill }) => (
  <svg
    width="25px"
    height="15px"
    viewBox="0 0 25 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g id="More" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="More_Account-settings-Password"
        transform="translate(-368.000000, -162.000000)"
        fill={fill}
        fillRule="nonzero"
      >
        <path
          d="M380.128895,176.999986 C385.636702,176.999986 390.285135,172.234365 391.964821,170.320305 C392.355446,169.851555 392.355446,169.148431 391.964821,168.679681 C390.285135,166.76562 385.636702,162 380.128895,162 C374.621087,162 369.972654,166.76562 368.292968,168.679681 C367.902344,169.148431 367.902344,169.851555 368.292968,170.320305 C369.972654,172.234365 374.621087,176.999986 380.128895,176.999986 Z M380.128895,175.749987 C375.167962,175.749987 370.832029,171.296866 369.230468,169.499993 C370.832029,167.70312 375.167962,163.249999 380.128895,163.249999 C385.089827,163.249999 389.425761,167.70312 391.027322,169.499993 C389.425761,171.296866 385.089827,175.749987 380.128895,175.749987 Z M380.128895,173.249996 C382.199205,173.249996 383.878898,171.570303 383.878898,169.499993 C383.878898,167.429682 382.199205,165.749996 380.128895,165.749996 C378.058584,165.749996 376.378898,167.429682 376.378898,169.499993 C376.378898,171.570303 378.058584,173.249996 380.128895,173.249996 Z M380.128897,171.999995 C378.761708,171.999995 377.628897,170.867179 377.628897,169.499995 C377.628897,168.132807 378.761708,166.999995 380.128897,166.999995 C381.496081,166.999995 382.628897,168.132807 382.628897,169.499995 C382.628897,170.867179 381.496081,171.999995 380.128897,171.999995 Z"
          id="eye"
        />
      </g>
    </g>
  </svg>
);

Eye.propTypes = {
  fill: PropTypes.string,
};

Eye.defaultProps = {
  fill: '#4a4a4a',
};

export default Eye;
